import { render, staticRenderFns } from "./sms-add-or-update.vue?vue&type=template&id=1da4b781"
import script from "./sms-add-or-update.vue?vue&type=script&lang=js"
export * from "./sms-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports